// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__21HTq","row":"ProcedureTreatmentSummary_row__1kAMt"};